import React, { useState } from 'react'
import TermToggle from './TermToggle'

const TermOptions = () => {
  const [is_long_term, setIsLongTerm] = useState(false)
  return (
    <div className=" w-full bg-white md:p-8 rounded-3xl grid grid-cols-1 md:grid-cols-2 gap-6 items-center  shadow-md">
      {/* coolumn 1  */}
      <div className=" w-full flex flex-col gap-4 p-4 md:p-0">
        <p className="  text-base  font-bold  text-black"> Term options</p>
        <h2 className="h2">Invest in your growth with competitive rates</h2>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
          Exclusive features, advanced conversion tools, and the lowest transaction fees* on
          Shopify—it’s all part of your plan.
        </p>
        <p className=" text-lightGray text-sm font-medium  leading-[27px] max-w-screen-md   md:mt-16 italic">
          *Transaction fees and credit card rates vary by region.
        </p>
      </div>
      {/* column 2 */}
      <div className=" bg-[#f8fafc] p-4  md:p-8 w-full h-full">
        <div className=" w-full h-full bg-white shadow-lg rounded-2xl">
          <TermToggle is_long_term={is_long_term} setIsLongTerm={setIsLongTerm} />
          <div className=" p-8 flex flex-col gap-2">
            <p className="text-base  font-bold  text-black">
              Starting at {is_long_term ? <span className=" line-through">$9,500</span> : ''}
            </p>
            <div className=" flex items-end justify-start gap-2">
              <h1 className="h1">{is_long_term ? '$2,300' : '$2,500'}</h1>
              <span className="  font-sm font-ormal  text-lightGray">USD/month</span>
            </div>
            <p className="text-lightGray text-[18px] font-medium  leading-[27px] mt-2">
              or a variable platform fee for more complex business structures
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermOptions
